
























import { Vue, Component } from "vue-property-decorator";
import router from "@/router/router";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";

@Component
export default class RoleSettingsAdministrationComponent extends Vue {
  isIntiallyLoading = false;

  onBack() {
    router.back();
  }

  mounted() {
    this.setToolbarTitle();
  }

  setToolbarTitle() {
    const baseTitle = this.$t("pages.settings").toString();
    const currentPageTitle = this.$t("settings.administration.roleSettings.title").toString();

    const toolbarTitle = baseTitle + " > " + currentPageTitle;

    ToolbarContentModule.setToolbarTitle(toolbarTitle);
  }
}
